
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'


export default {
name: "apply",
components: {Group, XInput, XButton},
data() {
return {
info: {
name: '',
mobile: ''
},
position: this.$route.query.position
}
},
methods: {
submit() {
if (!this.info.name || !this.info.mobile) {
alert('请填写基本信息')
return
}
if (this.$refs.file.files.length === 0) {
if (confirm('您没有上传简历，确认要提交么？')) {
this.$http.post('api/v1/resumes', {
openid: localStorage.getItem('openid'),
info: {
name: this.info.name,
mobile: this.info.mobile,
position: this.position,
appendix: []
}
}).then(() => {
alert('提交成功')
this.$router.push({name: 'resumelist'})
}).catch(error => {
this.$vux.alert.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
})
}
} else {
const formData = new FormData()
const fs = this.$refs.file.files
for (let i = 0; i < fs.length; i++) {
let d = fs[0]
if (d.size <= 1024 * 1024 * 100) {  //文件必须小于100M
formData.append("file", fs[i]);
formData.append("name", this.info.name + '-' + this.info.mobile + '-' + d.name);
} else {
alert('上传文件过大！')
return false
}
}
const arr = fs[0].name.split('.');
this.$http.post('api/v1/photos/upload', formData).then(response => {
this.$http.post('api/v1/resumes', {
openid: localStorage.getItem('openid'),
info: {
name: this.info.name,
mobile: this.info.mobile,
position: this.position,
appendix: [{type: arr[arr.length - 1], path: JSON.parse(response.data).path}]
}
}).then(() => {
alert('提交成功')
this.$router.push({name: 'resumelist'})
}).catch(error => {
this.$vux.alert.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
})
}).catch(error => {
this.$vux.alert.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
})
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/job/apply.vue